var announcementSlider = document.querySelector(".announcement-splide");
if (announcementSlider) {
  const splide = new Splide(announcementSlider, {
    type   : 'loop',
    drag   : 'free',
    focus  : 'center',
    arrows : false,
    pagination: false,
    perPage: 3.5,
    autoWidth: true,
    autoScroll: {
    speed: 1,
  },
    breakpoints: {
      359: {
        perPage: 1,
        gap: '1rem'
      },
      640: {
        perPage: 2,
        gap: '1rem'
      },
      768: {
        perPage: 3,
        gap: '1rem'
      },
      1024: {
        perPage: 3,
        gap: '1rem'
      },
    },
  });
  // Mount Splide
  splide.mount(window.splide.Extensions);
}



//********** */ TESTIMONIAL_SLIDER_JS_BEGINS ***********//



var testimonialSlider = document.querySelector(".testimonial-wrapper");
if (testimonialSlider) {
  const splide = new Splide(testimonialSlider, {
    type: 'loop',
    perPage: 3,
    perMove: 1,
    gap: '30px',
    pagination: true,
    arrows: false, // explicitly state arrows
    focus   : 'center',
    padding : { left: '9.35%', right: '9.35%' }, 
    breakpoints: {
      459: {
        perPage: 1,
        gap: '10px',
        focus: 'center',
        padding: { left: '12%', right: '12%' }
      },
      640: {
        type: 'loop',
        perPage: 1,
        gap: '1rem',
        focus: 'center',
        padding: { left: '12%', right: '12%' }
      },
      991: {
        perPage: 2,
        gap: '1rem'
      },
      1440: {
        perPage: 4,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (testimonialSlider.querySelector('.splide__arrows')) {
      testimonialSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}
//********** */ TESTIMONIAL_SLIDER_JS_ENDS ***********//

var featuredSlider = document.querySelector(".index_ftr_slider");
if (featuredSlider) {
  const splide = new Splide(featuredSlider, {
    type: 'loop',
    perPage: 4,
    perMove: 1,
    gap: '3.2rem',
    pagination: true,
    arrows: false, // explicitly state arrows
    breakpoints: {
      459: {
        perPage: 1,
        gap: '20px',
        focus: 'center',
        padding: { left: '0%', right: '17%' }
      },
      640: {
        type: 'loop',
        perPage: 1,
        gap: '1rem',
        focus: 'center',
        padding: '5%'
      },
      991: {
        perPage: 2,
        gap: '1rem'
      },
      1440: {
        perPage: 4,
        gap: '1.5rem'
      },
    },
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (featuredSlider.querySelector('.splide__arrows')) {
      featuredSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}

var blogSlider = document.querySelector(".index_blog_slider");
if (blogSlider) {
  const splide = new Splide(blogSlider, {
    type: 'loop',
    perPage: 2,
    perMove: 1,
    gap: '1px',
    pagination: true,
    arrows: false, // explicitly state arrows
    breakpoints: {
      359: {
        perPage: 1,
        gap: '1px',
         padding: { left: '0%', right: '20%' }
      },
      640: {
        type: 'loop',
        perPage: 1,
        gap: '1px',
         padding: { left: '0%', right: '20%' }
      },
      991: {
        perPage: 1.5,
        gap: '1px'
      },
      1024: {
        perPage: 2,
        gap: '1px'
      },
    },
  });
  
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (blogSlider.querySelector('.splide__arrows')) {
      blogSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}
  
function initRelProductSlider(container) {
  var relproductSlider = container.querySelector(".relslide");
  if (relproductSlider && !relproductSlider.classList.contains('splide-initialized')) {
    relproductSlider.classList.add('splide-initialized');

    const splide = new Splide(relproductSlider, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '3.2rem',
      pagination: true,
      arrows: false,
      breakpoints: {
        640: {
          perPage: 1,
          gap: '1rem',
          padding: { left: '0%', right: '20%' }
        },
        992: {
          perPage: 2,
          gap: '1.5rem'
        },
      },
    });

    splide.on('mounted', () => {
      const arrows = relproductSlider.querySelector('.splide__arrows');
      
    });

 

    splide.mount();
  }
}
// Watch for when recommendations load
const recommendations = document.querySelector('product-recommendations');
if (recommendations) {
  const observer = new MutationObserver(() => {
    initRelProductSlider(recommendations);
  });
  observer.observe(recommendations, { childList: true, subtree: true });
}

// Also run on normal page load
document.addEventListener("DOMContentLoaded", function () {
  initRelProductSlider(document);
});

document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".toggle-item");

    items.forEach((item) => {
      item.querySelector(".toggle-title").addEventListener("click", () => {
        item.classList.toggle("active");
      });
    });
  });

  function updateFreeShippingBar(cart) {
  const threshold = 199; // Free shipping threshold in USD
  const barWrapper = document.getElementById('FreeShippingBar');
  const message = document.getElementById('FreeShippingMessage');
  const progress = document.getElementById('FreeShippingProgress');

  if (!barWrapper || !message || !progress) return;

  const total = cart.total_price / 100; // Convert from cents to dollars
  const remaining = (threshold - total).toFixed(2);
  const percentage = Math.min((total / threshold) * 100, 100);

  progress.style.width = `${percentage}%`;
  barWrapper.style.display = 'block';

  if (total >= threshold) {
    message.textContent = 'You’ve qualified for free shipping';
  } else {
    message.textContent = `Add $${remaining} more for FREE shipping`;
  }
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => updateFreeShippingBar(cart));
});

// Update on cart changes (Shopify AJAX cart updates)
document.addEventListener('cart:updated', (event) => {
  if (event.detail && event.detail.cart) {
    updateFreeShippingBar(event.detail.cart);
  }
});

var testimonialSlider = document.querySelector(".collection-mobile");
if (testimonialSlider) {
  const splide = new Splide(testimonialSlider, {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    gap: '10px',
    pagination: true,
    arrows: false, // explicitly state arrows
    padding : { left: '0', right: '20%' }, 
  });
  // Add has-arrows class after Splide is mounted
  splide.on('mounted', () => {
    if (testimonialSlider.querySelector('.splide__arrows')) {
      testimonialSlider.classList.add('has-arrows');
    }
  });
  // Mount Splide
  splide.mount();
}



